<template>
  <div class="row container--stretch m-n">
    <!-- LEFT SIDE -->
    <div class="col-md-2 col-sm-3 hidden-xs no-padder left bg-grey">
      <div class="container-fluid p-y">
        <div>
          <articles></articles>
        </div>
        <div v-if="this.$store.getters.isStoreAvailable">
          <products></products>
        </div>
      </div>
    </div>
    <div class="col-md-10 col-sm-9 no-padder">
      <div class="container-fluid p-y">
        <div class="media-page-header m-t-0 m-b-sm b-n">
          <h1 class="m-n text-center text-u-c">Media</h1>
          <div v-if="isOwner" class="pull-right m-t-n-lg">
            <button @click="show()" type="button" class="btn btn-default btn-circle"><i class="glyphicon glyphicon-plus"></i></button>
          </div>
        </div>
        <hr style="width: 100%; margin: 10px 0;">

        <div v-if="empty" class="text-center text-muted" style="margin-top: 40px; font-style: italic; text-transform: lowercase;">no items found</div>
        <div class="row marginMd" infinite-scroll-distance="10">
          <div style="margin-top: 10px;" v-for="(item, i) in mediaItems" :key="i">
            <a @click="showMediaSlide(item)">
              <media-item @deleteMedia="showDeleteConfirm" :isOwner="isOwner" :media="item"></media-item>
            </a>
          </div>
        </div>
        <div v-if="loader">
          <pre-loader></pre-loader>
        </div>
        <div class="down-button-wrapper" v-if="!busy && !loader" @click="onScroll()">
          <img class="down-button" src="/vue-app/assets/img/down-arrow.svg">
        </div>

        <!-- Small Screen  -->
        <div class="item hidden-lg hidden-md hidden-sm">
          <articles></articles>
        </div>
        <div v-if="this.$store.getters.isStoreAvailable" class="item hidden-lg hidden-md hidden-sm">
          <products></products>
        </div>

      </div>
    </div>

    <modal name="delete-media-confirm-modal" height="auto" :scrollable="true">
      <div class="modal-content">
        <div class="closeModal" @click="hideDeleteConfirm">
          <a class="btn right btn-icon text-muted" href="#">
            <svg width="18px" height="18px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 224.512 224.512" style="enable-background:new 0 0 224.512 224.512;" xml:space="preserve"><g><polygon points="224.507,6.997 217.521,0 112.256,105.258 6.998,0 0.005,6.997 105.263,112.254 0.005,217.512 6.998,224.512 112.256,119.24 217.521,224.512 224.507,217.512 119.249,112.254" fill="#7d7d7d"></polygon></g></svg>
          </a>
        </div>
        <div class="modal-body">
          <section class="padder-v">
            <div class="panel-body">
              <center class="h3">Confirm delete this file?</center>
              <div class="m-t text-center">
                <button id="delete-media-btn-yes" class="btn btn-s-md btn-info" style="height:32px" @click="deleteMedia">YES</button>
                <button class="btn btn-s-md btn-danger" style="height:32px" @click="hideDeleteConfirm">NO</button>
              </div>
            </div>
          </section></div>
      </div>
    </modal>

    <modal name="add-media-modal" height="auto" :scrollable="true">
      <div class="modal-content" id="modal-content">
        <div class="closeModal" v-on:click="hide()">
          <a class="btn right btn-icon text-muted" href="#">
            <svg width="18px" height="18px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 224.512 224.512" style="enable-background:new 0 0 224.512 224.512;" xml:space="preserve"><g><polygon points="224.507,6.997 217.521,0 112.256,105.258 6.998,0 0.005,6.997 105.263,112.254 0.005,217.512 6.998,224.512 112.256,119.24 217.521,224.512 224.507,217.512 119.249,112.254" fill="#7d7d7d"></polygon></g></svg>
          </a>
        </div>
        <div class="modal-body" id="modal-body">
          <div class="panel-body">
            <section class="">
              <header class="panel-heading header-components bg-white m-t-n">
                <ul class="nav nav-tabs nav-components bg-white media-tabs ">
                  <li class="component_li active" data-type="photo" v-on:click="changeMediaType('image')">
                    <a href="#add-media-photo-tab" data-toggle="tab">
                      <i class="i i-images"></i>Photo</a>
                  </li>
                  <li class="component_li" data-type="video" v-on:click="changeMediaType('video')">
                    <a href="#add-media-video-tab" data-toggle="tab">
                      <i class="i i-video"></i>Video</a>
                  </li>
                  <li class="component_li" data-type="doc" v-on:click="changeMediaType('doc')">
                    <a href="#add-media-document-tab" data-toggle="tab">
                      <i class="i i-docs"></i>Document</a>
                  </li>
                </ul>
                <span class="hidden-sm">&nbsp;</span>
              </header>
              <div class="panel-body" style="text-align: left">
                <div class="tab-content">
                  <!-- PHOTO CONTENT -->
                  <div class="tab-pane active" id="add-media-photo-tab">
                    <form class="form-group m-b-n-xs">
                      <i class="i i-2x i-images text-info pull-left m-r-sm m-t-xxs"></i>
                      <input @change="setFile($event)" type="file" id="photo-FileInput" style="min-width: 400px; position: fixed; left: -700px;" class="filestyle" data-icon="false" data-classbutton="btn btn-default" data-classinput="form-control inline v-middle input-s bg-light lter"><div class="bootstrap-filestyle" style="display: inline;">
                      <input v-if="newMedia.file" v-model="newMedia.file.name" type="text" class="form-control inline v-middle input-s bg-light lter" disabled>
                      <input v-else type="text" class="form-control inline v-middle input-s bg-light lter" disabled>
                      <label for="photo-FileInput" class="btn btn-default"><span>Choose file</span></label></div>
                      <div id="photo-output" class="errorMessage"></div>
                      <div id="photo-image-container" class="padder-v"></div>
                    </form>
                  </div>

                  <!-- VIDEO CONTENT -->
                  <div class="tab-pane" id="add-media-video-tab">
                    <div class="input-group">
                      <span class="input-group-addon bg-light input-sm"><i class="fa fa-video-camera"></i></span>
                      <input v-model="newMedia.media_url" id="video-url" type="text" class="form-control input-small bg-light lter" placeholder="Enter YouTube URL" size="50">
                    </div>
                    <span v-if="validateError && submitted" class="errorMessage" id="video-url-message parsley-error-list">{{validateError}}</span>
                    <div class="clear clearfix"><br></div>
                  </div>

                  <!-- DOCUMENT CONTENT -->
                  <div class="tab-pane" id="add-media-document-tab">
                    <form class="form-group" id="document-form" method="POST" enctype="multipart/form-data" action="javascript:;">
                      <i class="i i-2x i-docs pull-left m-r-sm m-t-xs text-muted"></i>
                      <input @change="setFile($event)" type="file" name="FileInput" id="FileInput" class="filestyle" data-icon="false" data-classbutton="btn btn-default" data-classinput="form-control inline v-middle input-s bg-light lter" style="position: fixed; left: -700px;"><div class="bootstrap-filestyle" style="display: inline;">
                      <input v-if="newMedia.file" v-model="newMedia.file.name" type="text" class="form-control inline v-middle input-s bg-light lter" disabled>
                      <input v-else type="text" class="form-control inline v-middle input-s bg-light lter" disabled>
                      <label for="photo-FileInput" class="btn btn-default"><span>Choose file</span></label></div>
                      <br>
                      <small class="text-muted text-xs">file types doc, docx, ppt, pptx, pps, xls, xlsx, ps, odt, odp, txt, rtf, pdf ONLY with max 5MB size</small>
                      <div id="doc-output" class="errorMessage"></div>
                    </form>
                  </div>
                </div>

                <section id="image-option" class="m-b">
                  <form @submit.prevent="submitHandler" class="panel-body no-padder">
                    <div class="form-group">
                      <input v-model="newMedia.media_title" name="title" :class="{ 'is-invalid': submitted && errors.has('title') }" v-validate="{required:true}" type="text" id="media-title-tmp" placeholder="add title" class="form-control input-small" size="30">
                      <span v-if="submitted && errors.has('title')" class="help-block m-b-none parsley-error-list">{{errors.first('title')}}</span>
                    </div>
                    <div class="form-group">
                      <textarea id="media-desc-tmp" name="description"
                        v-model="newMedia.media_desc" v-validate="{required:true}"
                        :class="{ 'is-invalid': submitted && errors.has('description') }" 
                        class="form-control parsley-validated" style="resize: none;"
                        placeholder="add description" data-minwords="6" rows="3"></textarea>
                      <span v-if="submitted && errors.has('description')" class="help-block m-b-none parsley-error-list">{{errors.first('description')}}</span>
                    </div>

                    <div class="no-padder m-t-xs m-b-xs text-black">
                      <vue-tags-input
                        v-model="tag"
                        :tags="newMedia.media_tags"
                        :autocomplete-items="autocompleteItems"
                        :allow-edit-tags="true"
                        @tags-changed="tagChanged"
                      />
                    </div>
                    <div class="clear clearfix"></div><br>
                    <button id="upload-media" class="btn btn-sm btn-info pull-right" style="width: 70px;" :disabled="submitLoader">
                      <span v-if="!submitLoader">Upload</span>
                      <img v-if="submitLoader" style="width: 20px;" src="/vue-app/assets/img/loader-black.svg">
                    </button>
                    <span class="text-muted pull-right m-r-md">Max. 8MB file size</span>

                    <br><br>
                    <div v-if="submitted && errorMaxSize" class="clear clearfix text-right m-b-none parsley-error-list m-t-0">file uploaded exceeded max file size</div>
                  </form>
                </section>
              </div>
            </section>
          </div>
        </div>
      </div>
    </modal>

    <media-slide @close="showSlide = !showSlide" v-if="showSlide" :mediaItems="mediaSliderItems" :index.sync="selectedMedaSliderIndex"></media-slide>

  </div>
</template>

<script>
  import articles from '../../components/left-side/articles';
  import products from '../../components/left-side/products';
  import snapshoot from '../../components/about/snapshot';
  import mediaItem from '../../components/media/media';
  import mediaSlide from '../../components/media/media-slide';
  import ApiService from "../../../../services/ApiService";
  import VueTagsInput from '@johmun/vue-tags-input';

  export default {
    components: {
      articles,
      products,
      snapshoot,
      mediaItem,
      mediaSlide,
      VueTagsInput
    },
    data() {
      return {
        apiService: new ApiService(),
        mediaItems: null,
        mediaSliderItems: null,
        showSlide: false,
        lastMediaSliderIndex: 0,
        selectedMedaSliderIndex: null,
        loader: false,
        busy: false,
        empty: false,
        isOwner: false,
        type: null,
        deletionMediaId: null,
        perPage: 12,
        page: 1,
        // @TODO move these constant values into separate file
        typeImage: 'image',
        typeVideo: 'video',
        typeDoc: 'doc',
        validateError: '',
        submitLoader: false,
        submitted: false,
        errorMaxSize: false,
        autocompleteItems: [],
        tag: '',
        tags: [],
        newMedia: {
          file: null,
          profile_id: null,
          owner_type: 'profile',
          media_type: 'image',
          media_title: '',
          media_desc: '',
          media_url: '',
          media_tags: [],
          // extension:''
        }
      }
    },
    created() {
      this.getMedia();
      this.mediaInit();
      this.defineOwner();
      this.fetchTags();
    },
    watch: {
      tag: function(tag) {
        this.autocompleteItems = this.tags.filter(i => {
          return i.text.toLowerCase().indexOf(tag.toLowerCase()) !== -1;
        });
      },
      mediaItems: function (to) {
        this.mediaItems = to;
      }
    },
    computed:{
      profile(){
        return this.$store.getters.profile;
      }
    },
    methods: {
      defineOwner() {
        this.isOwner = this.profile.profile_id === window.user.profile_id;
      },
      getMedia(merge = false) {
        let This = this;
        if(!this.busy && !this.loader) {
          this.loader = true;
          this.apiService.get(`/media?community_id=${window.user.community_id}&page=${this.page}&per-page=${this.perPage}&profile_id=${this.profile.profile_id}`)
            .then(res => {
              if(!merge) {
                This.lastMediaSliderIndex = 0;
              }

              res.items.map(e => {
                e.url = This.addAWS(e.url);
                e.mediaSliderIndex = (e.type == This.typeVideo || e.type == This.typeImage) ? This.lastMediaSliderIndex++ : null;                
                e.thumbs['thumb'] = This.addAWS(e.thumbs['thumb']);
                e.thumbs['thumb-lg'] = This.addAWS(e.thumbs['thumb-lg']);
                e.thumbs['thumb-sm'] = This.addAWS(e.thumbs['thumb-sm']);
                e.thumbs['thumb-xs'] = This.addAWS(e.thumbs['thumb-xs']);
              });

              This.busy = res._meta.currentPage >= res._meta.pageCount;
              This.empty = res._meta.totalCount === 0;
              if(merge) {
                This.mediaItems = This.mediaItems.concat(res.items);
              } else {
                This.mediaItems = res.items;
              }
              This.setMediaSliderItems();
              This.loader = false;              
            })
        }
      },
      onScroll() {
        this.page++;
        this.getMedia(true);
      },
      addAWS(url) {
        if (!/^(f|ht)tps?:\/\//i.test(url)) {
          url =  process.env.AWS_URL + "/" + url;
        }
        return url;
      },
      mediaInit () {
        this.newMedia = {
          file: null,
          album_id: 0,
          profile_id: this.profile.profile_id,
          owner_type: 'profile',
          owner_id: this.profile.profile_id,
          media_type: 'image',
          media_title: '',
          media_desc: '',
          media_url: '',
          media_tags: []
        };
        this.submitted = false;
        this.errorMaxSize = false;
      },
      changeType(type = null) {
        this.busy = false;
        this.page = 1;
        this.type = type;
        this.getMedia()
      },
      showMediaSlide (item) {
        if(item.mediaSliderIndex !== null) {
          this.selectedMedaSliderIndex = item.mediaSliderIndex;
          this.showSlide = true;
        } else if(item.type == this.typeDoc) {
          window.open(item.url, '_blank');
        }
      },
      show () {
        this.$modal.show('add-media-modal');
      },
      hide () {
        this.mediaInit();
        this.$modal.hide('add-media-modal');
      },
      deleteMedia () {
        if(this.deletionMediaId) {
          this.busy = false;
          this.page = 1;
          this.loader = true;
          this.mediaItems = null;
          this.apiService.delete(`/media/${this.deletionMediaId}`)
            .then(res => {
              this.loader = false;
              this.getMedia();
              this.hideDeleteConfirm();
              this.loader = false;
            })
            .catch(error => {
              this.$toaster.error(error.data.message);
              this.hideDeleteConfirm();
              this.loader = false;
            });

          this.$modal.hide('delete-media-confirm-modal');
        }
      },
      showDeleteConfirm (id = null) {
        this.deletionMediaId = id;
        this.$modal.show('delete-media-confirm-modal');
      },
      hideDeleteConfirm () {
        this.mediaInit();
        this.$modal.hide('delete-media-confirm-modal');
      },
      changeMediaType (type) {
        this.newMedia.media_type = type;
        this.newMedia.file = null;
      },
      setFile ($event) {
        let fileName = $event.target.files[0].name;
        // this.newMedia.extension = fileName.split('.')[fileName.length-1] 
        this.newMedia.file = $event.target.files[0];
      },
      newMediaValidate () {
        if(!this.newMedia.file && this.newMedia.media_type != this.typeVideo) {
          this.validateError = 'File required.';
          return false;
        }
        if(!this.newMedia.media_url && this.newMedia.media_type == this.typeVideo) {
          this.validateError = 'Youtube url required.';
          return false;
        }
        if(!this.validateYouTubeUrl(this.newMedia.media_url) && this.newMedia.media_type == this.typeVideo) {
          this.validateError = 'Youtube url not validate.';
          return false;
        }
        // if(this.newMedia.media_type == 'image'){
        //   return ['jpg','jpeg','gif','png','tif'].includes(this.newMedia.extension);
        // }
        // else if(this.newMedia.media_type == 'video'){
        //   return ['mp4','3gp','ogg','wmv','webm','flv','avi'].includes(this.newMedia.extension);
        // }
        // else if(this.newMedia.media_type == 'doc'){
        //   return ['doc','docx','ppt','pptx','pps','xls','xlsx','ps','odt','odp','txt','rtf','pdf'].includes(this.newMedia.extension);
        // }
        return true;
      },
      submitHandler () {
        this.submitted = true;
        this.$validator.validate().then(valid => {
          if(valid) {
            if (!this.newMediaValidate()) return;
            this.submitLoader = true;
            this.errorMaxSize = false;
            this.apiService.post(`/media/create`, this.preparingBody())
              .then(res => {
                this.submitLoader = false;
                this.busy = false;
                this.mediaItems = null;
                this.page = 1;
                this.getMedia();
                this.$toaster.success('Media added succesfully');
                this.hide();
                this.mediaInit();
                this.fetchTags();
              })
              .catch(error => {
                this.submitLoader = false;
                if(error.status === 413) {
                  this.errorMaxSize = true;
                }
                else this.$toaster.error('Unable to create media');
              });
          }
        });
      },
      preparingBody() {
        var formData = new FormData();
        if (this.newMedia.file) formData.append('file', this.newMedia.file, this.newMedia.file.name);
        formData.append('owner_id', this.newMedia.owner_id);
        formData.append('owner_type', this.newMedia.owner_type);
        formData.append('media_type', this.newMedia.media_type);
        formData.append('media_title', this.newMedia.media_title);
        formData.append('media_desc', this.newMedia.media_desc);
        formData.append('media_url', this.newMedia.media_url);
        formData.append('album_id', this.newMedia.album_id);
        let media_tags = this.newMedia.media_tags.map(tag => {
          return {id: tag.id, tag: tag.text};
        });
        formData.append('tags', JSON.stringify(media_tags));
        return formData;
      },
      validateYouTubeUrl(url) {
        if (url != undefined || url != '') {
          var regExp = /(youtube\.com|youtu\.be).*(\?v=|\/embed\/&\/)(.{11})/g;
          var match = url.match(regExp);
          return match ? true : false;
        }
        return false;
      },
      fetchTags() {
        this.apiService.get(`/tags`)
          .then(res => {
            this.tags = res.items.map(item => {
              return { id: item.id, text: item.tag}
            });
            this.autocompleteItems = this.tags;
          });
      },
      tagChanged(newTags) {
        this.newMedia.media_tags = newTags;
        this.tag = '';
      },
      setMediaSliderItems(){
        this.mediaSliderItems = this.mediaItems.filter(e => {
          return e.mediaSliderIndex !== null;
        });
      }
    }
  }
</script>

<style scoped>
  .vue-tags-input {
    max-width: 1000px;
    font-size: 14px;
    font-weight: normal !important;
  }
</style>
<style lang="scss">
  .vue-tags-input .ti-tag {
    color: #555555;
    background: white;
    border: 1px solid #cbd5dd;
    font-size: 14px;
  }
  .vue-tags-input {
    max-width: 1000px;
    font-size: 14px;
    font-weight: normal !important;
  }
  .vue-tags-input .ti-deletion-mark {
    color: #555 !important;
    background-color: #999 !important;
    font-size: 14px;
  }
  @import "~@styles/media.scss";
  .lazy-image-placeholder {
    background-position: center center;
    background-repeat: no-repeat;
    background-size: auto;
  }
  .lazy-image {
    max-width: 100% !important;
  }
  .media-page-header {
    margin-top: 17px;
    margin-bottom: 17px;
  }
  .media-page-header h1 {
    font-style: normal;
    font-weight: 300;
    color: #000;
    font-size: 20px;
    line-height: 23px;
    text-align: center;
    letter-spacing: 0.72px;
  }
  .down-button-wrapper {
    margin: 20px 0;
    width: 100%;
  }
  .down-button {
    cursor: pointer;
    width: 32px;
    margin-left: calc(50% - 16px);
  }
  @media only screen and (min-width: 1201px) {
    .media-page-header h1 {
      font-size: 24px;
      line-height: 28px;
    }
  }
  @media only screen and (max-width: 1200px) and (min-width: 1024px) {
    .media-page-header h1 {
      font-size: 20px;
      line-height: 23px;
    }
  }
  @media only screen and (max-width: 1023px) and (min-width: 768px) {
    .media-page-header h1 {
      font-size: 20px;
      line-height: 23px;
    }
  }
  @media only screen and (max-width: 767px) {
    .media-media-page-headerer h1 {
      font-size: 20px;
      line-height: 23px;
    }
    .v--modal-box {
      max-width: 360px;
    }
    .add-media-modal {
      max-width: 360px;
      left: calc(50% - 180px);
      position: fixed !important;
    }
    .modal-content {
      max-width: 360px;
      top: 60px;
      left: calc(50% - 180px);
      position: fixed !important;
    }
    .modal-body {
      max-width: 360px;
    }
  }

  .has-error .form-control {
    border-color: #F44455;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.075) inset;
  }
  span.required,.errorMessage{
    color: #F44455;
  }
  input .error{
    border-color: #F44455 !important;
  }
</style>
